// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2diZH","content":"styles_content__1xGFu","row":"styles_row__1xkT-","footer":"styles_footer__2v2yh","phraseLength":"styles_phraseLength__7lqBY"};